export function setInitialSettings(state, payload) {
  return {
    ...state,

    initialSettings: payload,
  }
}

export default {}
